module.exports = __webpack_public_path__ + "static/media/demo-simple.772b724.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/demo-simple.mp4
// module id = OdHm
// module chunks = 1 2